module.exports = __webpack_public_path__ + "static/media/diritto-societario.583c61dc.jpg";